package com.essntl.features.proposal.ui.selectservice.components

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.dp
import com.essntl.features.profile.domain.model.ProfileModel
import com.mohamedrejeb.compose.dnd.DragAndDropState
import com.mohamedrejeb.compose.dnd.drag.DraggableItem
import com.mohamedrejeb.compose.dnd.rememberDragAndDropState
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.ui.addeditproposal.components.ProposalServiceCard
import com.essntl.features.proposal.ui.selectservice.SelectServiceEvent
import com.essntl.features.proposal.ui.selectservice.SelectServiceNavigation
import com.essntl.features.proposal.ui.selectservice.SelectServiceState
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.service.ui.allservice.components.LoadMoreItems
import com.essntl.features.service.ui.components.ServiceFilterSection
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersState
import com.essntl.uikit.components.button.primary.EsMediumPrimaryButton
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.scroll.EsVerticalScrollbar
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberContains
import com.essntl.uikit.rememberFind
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.delay

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun ServiceColumn(
    state: SelectServiceState,
    onEvent: (SelectServiceEvent) -> Unit,
    onNavigation: (SelectServiceNavigation) -> Unit,
    allSupplierState: AllSuppliersState,
    onEventAllSupplier: (AllSuppliersEvent) -> Unit,
    dragAndDropState: DragAndDropState<Pair<ServiceModel, ProposalServiceModel>> = rememberDragAndDropState(),
    isDragEnabled: Boolean = false,
    onArrowClick: () -> Unit = {},
    showArrow: Boolean = false,
    modifier: Modifier = Modifier,
) {
    val currentUserRole = remember(state.getCurrentProfile.data) {
        state.getCurrentProfile.data?.role
    }

    val gridState = rememberLazyGridState()

    var searchText by remember { mutableStateOf("") }

    LaunchedEffect(searchText) {
        delay(500L)

        onEvent(
            SelectServiceEvent.FilterServices(
                state.filterOptions.copy(
                    searchText = searchText,
                ),
            ),
        )
    }

    Column(
        modifier =
            modifier
                .fillMaxWidth(),
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier =
                Modifier
                    .fillMaxWidth()
                    .clip(
                        RoundedCornerShape(
                            bottomStart = 24.dp,
                            bottomEnd = 24.dp,
                        ),
                    )
                    .background(MaterialTheme.esColorScheme.bgSecondary)
                    .padding(
                        top = 1.5f.spacing,
                        bottom = 2.5f.spacing,
                    )
                    .padding(
                        horizontal = 2.5f.spacing,
                    ),
        ) {
            Row(
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth(),
            ) {
                if (showArrow) {
                    EsMediumOutlineIconButton(
                        onClick = onArrowClick,
                        iconRes = EsIcons.ArrowRight,
                    )
                    Spacer(modifier = Modifier.width(1.spacing))
                }

                EsInput(
                    value = searchText,
                    onValueChange = {
                        searchText = it
                    },
                    prefix = {
                        EsLargeIcon(
                            res = EsIcons.Search,
                        )
                    },
                    placeholder = "Search",
                    modifier = Modifier.weight(2f),
                )

                if (currentUserRole == ProfileModel.Role.Admin ||
                    currentUserRole == ProfileModel.Role.Supervisor ||
                    currentUserRole == ProfileModel.Role.Owner
                ) {
                    Spacer(modifier = Modifier.width(1.spacing))

                    EsMediumPrimaryButton(
                        onClick = {
                            onNavigation(SelectServiceNavigation.AddService)
                        },
                        text = "New service",
                        modifier = Modifier.weight(1f),
                    )
                }
            }

            Spacer(modifier = Modifier.height(1.5.spacing))

            ServiceFilterSection(
                categoryList = state.getAllCategory.data.orEmpty().sortedBy { it.name },
                tagList = state.getAllTag.data.orEmpty().sortedBy { it.name.lowercase() },
                areaList = state.getAllArea.data.orEmpty().sortedBy { it.name },
                filterOptions = state.filterOptions,
                isCategoryLoading = state.getAllCategory.isLoading,
                isTagLoading = state.getAllTag.isLoading,
                isAreaLoading = state.getAllArea.isLoading,
                isSupplierFilterEnabled = true,
                allSuppliersState = allSupplierState,
                onEventAllSupplier = onEventAllSupplier,
                onFilterOptionsChange = {
                    onEvent(SelectServiceEvent.FilterServices(it))
                    if (it == ServiceFilterOptions()) {
                        searchText = ""
                    }
                },
                modifier = Modifier.fillMaxWidth(),
            )
        }

        Spacer(modifier = Modifier.height(1.5f.spacing))

        Box(
            contentAlignment = Alignment.Center,
            modifier =
                Modifier
                    .fillMaxWidth()
                    .weight(1f),
        ) {
            if (state.getAllService.isLoading && state.getAllService.data.isEmpty()) {
                EsSpinner()
            } else if (state.getAllService.isFailure) {
                Text(
                    text = "Something goes wrong!",
                    color = MaterialTheme.esColorScheme.textSecondary,
                    style = MaterialTheme.esTypography.p1Medium16,
                )
            } else if (state.getAllService.data.isEmpty()) {
                Text(
                    text = "No service found!",
                    color = MaterialTheme.esColorScheme.textSecondary,
                    style = MaterialTheme.esTypography.p1Medium16,
                )
            } else {
                Row(
                    modifier =
                        Modifier
                            .fillMaxSize(),
                ) {
                    LazyVerticalGrid(
                        columns = GridCells.Fixed(2),
                        state = gridState,
                        verticalArrangement = Arrangement.spacedBy(1.spacing),
                        horizontalArrangement = Arrangement.spacedBy(1.spacing),
                        modifier =
                            Modifier
                                .weight(1f)
                                .fillMaxHeight(),
                    ) {
                        items(state.getAllService.data, key = { it.id }) { service ->
                            DraggableItem(
                                key = service.id,
                                state = dragAndDropState,
                                data =
                                    remember(service) {
                                        service to
                                            ProposalServiceModel.empty.copy(
                                                id = "drag",
                                                service = service,
                                                editedDescription = service.description,
                                            )
                                    },
                                draggableContent = {
                                    ProposalServiceCard(
                                        service = service,
                                    )
                                },
                                enabled = isDragEnabled,
                            ) {
                                val category = rememberFind(
                                    state.getAllCategory.data.orEmpty(),
                                    service.category,
                                ) { cat -> cat.id }

                                val tagList = rememberContains(
                                    state.getAllTag.data.orEmpty(),
                                    service.tags.orEmpty(),
                                ) { tag -> tag.id }

                                EsTooltip(
                                    text = service.title,
                                ) {
                                    ServiceCard(
                                        service = service,
                                        category = category,
                                        tagList = tagList,
                                        onClick = {
                                            onNavigation(SelectServiceNavigation.ClickService(service))
                                        },
                                        onDoubleClick = {
                                            onNavigation(
                                                SelectServiceNavigation.EditService(
                                                    service = service,
                                                    enableEdit = false,
                                                ),
                                            )
                                        },
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .graphicsLayer {
                                                alpha = if (isDragging) 0.5f else 1f
                                            },
                                    )
                                }
                            }
                        }

                        if (state.getAllService.hasMore) {
                            item(
                                key = "load-more",
                                span = {
                                    GridItemSpan(maxLineSpan)
                                },
                            ) {
                                LoadMoreItems(
                                    onLoadMore = {
                                        onEvent(SelectServiceEvent.LoadMoreServices)
                                    },
                                    isLoading = state.getAllService.isLoading,
                                    modifier = Modifier.fillMaxWidth(),
                                )
                            }
                        }
                    }

                    EsVerticalScrollbar(
                        lazyGridState = gridState,
                        modifier =
                            Modifier
                                .fillMaxHeight(),
                    )
                }
            }
        }
    }
}
